import { Component, OnInit } from '@angular/core';

@Component({
    template: `

    `,
    selector: 'hp-root'
})
export class AppComponent implements OnInit {
    title = 'American Airlines - Airline tickets and cheap flights at AA.com';

    constructor() {
    }

    public ngOnInit(): void {
    }
}
